module.exports = __webpack_public_path__ + "img/catseye05.7ea3a903.gif";